import { Fragment } from 'vue';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var appendOurFnToHandlers = function appendOurFnToHandlers(oldHandlers, ourFn) {
  if (!oldHandlers) {
    return ourFn;
  }
  if (Array.isArray(oldHandlers)) {
    return oldHandlers.indexOf(ourFn) > -1 ? oldHandlers : oldHandlers.concat(ourFn);
  }
  return oldHandlers === ourFn ? oldHandlers : [oldHandlers, ourFn];
};
var removeOurFnToHandlers = function removeOurFnToHandlers(oldHandlers, ourFn) {
  if (oldHandlers && Array.isArray(oldHandlers)) {
    var ourFnIndex = oldHandlers.indexOf(ourFn);
    if (ourFnIndex > -1) {
      oldHandlers.splice(ourFnIndex, 1);
    }
  }
  return oldHandlers;
};
var operateEventOfNode = function operateEventOfNode(node, eventName, ourFn, mode) {
  var props = node.props ? node.props : {};
  if (mode === 'bind') {
    props[eventName] = appendOurFnToHandlers(props[eventName], ourFn);
  } else if (mode === 'remove') {
    props[eventName] = removeOurFnToHandlers(props[eventName], ourFn);
  }
  node.props = _objectSpread2({}, props);
};
var bindOurFnToEventOfNode = function bindOurFnToEventOfNode(node, eventName, ourFn) {
  operateEventOfNode(node, eventName, ourFn, 'bind');
};
var removeOurFnFromEventOfNode = function removeOurFnFromEventOfNode(node, eventName, ourFn) {
  operateEventOfNode(node, eventName, ourFn, 'remove');
};
var bindPropToNode = function bindPropToNode(node, PropName, PropValue) {
  var props = node.props ? node.props : {};
  props[PropName] = PropValue;
  node.props = _objectSpread2({}, props);
};
/**
 * flat vnodes，移除vnodes中的Fragment
 * @param vnodes vnode数组
 * @returns vnodes
 */
function flatVnodes(vnodes) {
  var flatedVNodes = [];
  vnodes.forEach(function (vnode) {
    if (vnode.type === Fragment && Array.isArray(vnode.children)) {
      flatedVNodes = flatedVNodes.concat(flatVnodes(vnode.children));
    } else {
      flatedVNodes.push(vnode);
    }
  });
  return flatedVNodes;
}

export { bindOurFnToEventOfNode, bindPropToNode, flatVnodes, removeOurFnFromEventOfNode };
